























































































































































































































































import {Component, Mixins, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import moment from 'moment'
import FooterLink from './FooterLink.vue'
import CookieConsentBanner from '@/components/cookieConsentBanner/CookieConsentBanner.vue'
import AccordionFooter from './AccordionFooter.vue'
import {NetworkModeHelper} from '@/helpers/NetworkModeHelper'

@Component({
  components: {CookieConsentBanner, FooterLink, AccordionFooter},
})
export default class AppFooter extends Mixins(MixinScreenSize) {
  @Prop({type: String, required: false}) addToList!: string

  /** Same rule as the navbar: no links to pages the network in use has not got. */
  isAvailable(routeName: string): boolean {
    return NetworkModeHelper.isRouteAvailable(routeName)
  }

  get year() {
    return moment().year()
  }

  get addToListString() {
    return (
      this.$translate('components.footer.contact.addYour') +
      this.addToList +
      this.$translate('components.footer.contact.toTheList')
    )
  }
}
